import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Money } from "../../../../../../../../Wrap/Core/DataTypes/Money";
import { Typography } from "../../../../../../../Shared/Typography/Typography";
import { SectionHeader } from "../../../../AddClient/Components/SharedComponents";
import { FrequencyArraysMap } from "../../../../Common/Resource/Contents";
import { incomePaymentDetailsLabels } from "../../../Resource/Contents";
import { getAnnualIncomeBasedOnFrequency } from "../../../Resource/Helper";
import { DrawdownIncomeAmendmentModel } from "../../../../../../../../Wrap/Models/Models/Processes/Drawdown/DrawdownIncomeAmendmentModel";
import { MoneyHelper } from "../../../../../../../Shared/Common/MoneyHelper";

interface IPaymentDetailsProps {
    data: DrawdownIncomeAmendmentModel;
    arrangementId: number;
    arrangementValuationForGADReview?: number;
}

interface IPaymentDetailsState {}

export class PaymentDetails extends FormComponent<IPaymentDetailsProps, IPaymentDetailsState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { data, arrangementId, arrangementValuationForGADReview } = this.props;
        return (
            <>
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.totalPostRetirementAccountValue}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {this.getMoneyDisplay({Amount: arrangementValuationForGADReview, Currency: CurrencyCode.GBP})}
                    </span>
                </div>
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.expectedGadMaximum}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {this.getMoneyDisplay({Amount: data?.PensionLevelDrawdownIncomeAmendmentCalculations?.CappedArrangementsIncomeDetail?.filter(x => x.ArrangementId == arrangementId)?.[0]?.NextGadMaximum, Currency: CurrencyCode.GBP})}
                    </span>
                </div>
                {SectionHeader("Future pension year income")}
                <div className="row">
                    <div className="col-12 col-sm-fluid">
                        <h4>Before</h4>
                        <Typography
                            type={"auto-width"}
                            config={this.getValues(data?.ExistingDrawdownIncome?.AnnualIncome, true)}
                        />
                    </div>

                    <div className="col-12 col-sm-fluid">
                        <h4>After</h4>
                        <Typography
                            type={"auto-width"}
                            config={this.getValues(data?.DrawdownIncomeAmendmentInstruction?.Income, false)}
                        />
                    </div>
                </div>
            </>
        );
    }

    private getValues(data: any, isExistingValues: boolean) {
        const showCappedIncomePerPaymentForFuturePensionYears: boolean = !isExistingValues && data?.TargetSpecificArrangements && (data?.GrossIncomePerPaymentFromPension?.Amount ?? 0) == 0
        const currentCappedArrangmentInstruction = this.props.data?.DrawdownIncomeAmendmentInstruction?.CappedArrangements?.find(x => x.PensionArrangementId == this.props.arrangementId);
        const currentCappedIncomePerPaymentForFuturePensionYears = { Amount: currentCappedArrangmentInstruction?.IncomePerPaymentForFuturePensionYears, Currency: MoneyHelper.getDefaultCurrency() };

        const incomePerPayment = data?.TargetSpecificArrangements
            ? data?.GrossIncomePerPaymentFromPension > 0
            : data?.GrossIncomePerPayment;

        const annualIncome = getAnnualIncomeBasedOnFrequency(incomePerPayment, data?.Frequency);
        const annualIncomePaymentForFuturePensionYears = getAnnualIncomeBasedOnFrequency(currentCappedIncomePerPaymentForFuturePensionYears, data?.Frequency);
        return [
            { title: "Payment frequency", data: FrequencyArraysMap[data?.Frequency] },
            {
                title: isExistingValues ? "Next payment date" : "First payment date",
                data: annualIncome?.Amount > 0 || annualIncomePaymentForFuturePensionYears?.Amount > 0 ? JsonDateParser.getFormatDate(data?.NextPayment, "dd/MM/yyyy") : null,
            },
            {
                title: showCappedIncomePerPaymentForFuturePensionYears ? "Income payment for future pension years" : "Expected gross annual income",
                data: showCappedIncomePerPaymentForFuturePensionYears ? annualIncomePaymentForFuturePensionYears.Amount : (annualIncome?.Amount > 0 ? this.getMoneyDisplay(annualIncome) : null),
            }
        ];
    }

    private getMoneyDisplay(data: Money) {
        return MoneyDisplayHelper.FromatMoneyDisplay(data?.Amount, data?.Currency || CurrencyCode.GBP);
    }
}
